export const defaultWhiteLabelColors = {
    graphic_colors: {
        default: '602DF3',
        light: '716FF4',
        dark: '230F5B',
    },
    primary_button: {
        hover: '2F1FD1',
        default: '3A29E8',
        outlined: false,
        active: '2013AC',
    },
    primary_button_content: {
        hover: 'FFFFFF',
        default: 'FFFFFF',
        active: 'FFFFFF',
    },
    secondary_button: {
        hover: '2F1FD1',
        default: 'FFFFFF',
        outlined: false,
        active: '2013AC',
    },
    secondary_button_content: {
        hover: 'FFFFFF',
        default: '2F1FD1',
        active: 'FFFFFF',
    },
    links: {
        hover: '3A29E8',
        default: '2013AC',
        underlined: true,
        active: '5948FF',
    },
    icons: {
        hover: '3F2DF3',
    },
    selectors: {
        active: '3A29E8',
    },
    email_button: {
        hover: '2F1FD1',
        default: '3A29E8',
        outlined: false,
        active: '2013AC',
    },
    email_button_content: {
        hover: 'FFFFFF',
        default: 'FFFFFF',
        active: 'FFFFFF',
    },
};
